import(/* webpackMode: "eager", webpackExports: ["Custom404"] */ "/home/runner/actions-runner/_work/mnd-publish-frontend/mnd-publish-frontend/apps/public/components/404.tsx");
